<script>
/**
 * @desc 公共nav组件
 * <com-nav
    :data="navType"
    :info="$store.state.info"
    :logoImg="logoImg"
    ></com-nav>
 */
import navGtlc from './gtlc-nav'
import navAs from './as-nav'
import navAsopacity from './as-nav-opacity'
import navQcon from './qcon-nav'
export default {
  components: {
    navGtlc, // GTLC 风格
    navAs, // AS 风格
    navAsopacity, // AS 透明
    navQcon // QCon
  },
  props: {
    // 大会信息
    info: {
      type: Object
    },
    type: {
      type: String
    },
    // logo图
    logoImg: {
      type: Object
    }
  },
  render () {
    const Tag = `nav-${this.type}`
    return (<Tag info={this.info} type={this.type} logoImg={this.logoImg}></Tag>)
  }
}
</script>
